import { render, staticRenderFns } from "./shootingbook.vue?vue&type=template&id=de45cb48&scoped=true"
import script from "./shootingbook.vue?vue&type=script&lang=js"
export * from "./shootingbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de45cb48",
  null
  
)

export default component.exports